import { Flex, useDisclosure } from "@chakra-ui/react";
import ExportButton from "components/Customers/ExportButton";
import CustomersTableView from "components/Customers";
import Layout from "components/Layout";
import PageSection from "components/Layout/PageSection";
import HeadTitle from "components/Shared/HeadTitle";
import CreateButton from "components/Shared/CreateButton";
import DirectoryModal from "components/Customers/DirectoryModal";

export default function CustomersIndex() {
  const {
    isOpen: isCreateOpen,
    onOpen: onOpenCreate,
    onClose: onCloseCreate,
  } = useDisclosure();

  return (
    <PageSection
      display="flex"
      flexFlow="column"
      height="100%"
      width="100%"
      isUnpadded
    >
      <HeadTitle title="Customers" />

      <CustomersTableView
        headerRight={
          <Flex
            justifyContent="flex-end"
            alignItems="center"
            flexFlow="row wrap"
            pr={4}
          >
            <ExportButton />

            <CreateButton ml={4} onClick={onOpenCreate}>
              Add
            </CreateButton>
          </Flex>
        }
      />

      <DirectoryModal isOpen={isCreateOpen} onClose={onCloseCreate} />
    </PageSection>
  );
}

CustomersIndex.getLayout = (page: React.ReactElement) => (
  <Layout isFullHeight>{page}</Layout>
);
